import { IJsonQuery } from '../../types/interfaces';

export function needDefaultRegion(jsonQuery: IJsonQuery): boolean {
  const jsonQueryParams = Object.keys(jsonQuery);
  const requiredParams = ['region', 'builders', 'builder_id', 'geo', 'polygon', 'newbuilding_id'];
  const intersections = jsonQueryParams.find(e => requiredParams.includes(e));

  return !intersections;
}
